import React from 'react';
import MyAccount from './myaccount';

export default class Account extends React.Component {
  render () {
    return <div className="header__account">
      <div className="header__account__inner">
        <MyAccount {...this.props} />
      </div>
    </div>;
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/header/account/index.js